import { makeSvgImage } from '../../../../../../components/SvgImage/index.ts';

export const DarkCloudB = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 49">
    <path
      fill="#EFF7FF"
      fillRule="evenodd"
      d="M14 45.5h126A19.8 19.8 0 0 0 117.5 21a31.2 31.2 0 0 0-60.4 6.6 12.4 12.4 0 0 0-15.4 5.6A12.4 12.4 0 0 0 28.5 38 9 9 0 0 0 14 45.5Z"
      clipRule="evenodd"
    />
    <rect width="150" height="2.7" y="45.5" fill="#EFF7FF" rx="1.3" />
  </svg>,
);
